import { KioskResource } from './KioskResource';

export class WelcomeAndKioskResource {
    rid: number;
    kiosk: KioskResource;
}